import React from "react";
import HomePage from "./containers/HomePage";
const App: React.FC = () => {
  return <HomePage />;
};

export default App;
